// periods
import React, { useMemo, useRef } from 'react';
import {
    gql, useFragment, useReactiveVar,
} from '@apollo/client';
import { selectedPeriodVar } from 'app/apollo/reaction';
import { getWeekByDate } from 'app/utils/weekByDate';
import { useMenuPeriodsData } from './useMenuPeriodsData';

const D_SPECIFIC_PERIOD_FRAGMENT = gql`
fragment ALL_FILTER_PERIODS_FRAGMENT on periods {
    start
    end
    isVisibleInFilter
    categories {
        id
        title
        description
        __typename
    }
    tags {
        id
        title
        categoryId: category_id
        categoryName: category_name
        erp_id
    }
}`;

/**
 * @description читает данные конкретного периуда и cache
 */
export const useSpecificPeriodData = (fragment = D_SPECIFIC_PERIOD_FRAGMENT) => {
    const period = useReactiveVar(selectedPeriodVar);
    const { periods } = useMenuPeriodsData();

    const patchedPeriod = useMemo(
        () => periods?.find((p) => p.start === period),
        [period, periods],
    );

    const { data } = useFragment({
        fragment,
        from: {
            __ref: `periods:${getWeekByDate(period)}`,
        },
    });

    const lastValidDataRef = useRef(patchedPeriod || data);

    return useMemo(() => {
        const nextData = patchedPeriod || data;

        if (nextData?.start) {
            lastValidDataRef.current = nextData;
            return nextData;
        }

        return lastValidDataRef.current;
    }, [patchedPeriod, data]);
};
